import * as session from '../session';
import {extendPromise} from '../extend-promise';
import {handleRequestError} from '../errors';

const baseUrl = window.location.protocol + '//' + window.location.hostname + ':3001/api';
//const baseUrl = 'http://18.198.129.107:3001/api';
console.log('Server url', baseUrl);


export function method(method, body = {}) {
  const headers = {
    'content-type': 'application/json'
  };

  if(session.getUser()) {
    headers.authorization = 'Bearer ' + session.getUser().accessToken;
  }

  const req = fetch(`${baseUrl}/${method}`, {
    method: 'post',
    headers: headers,
    body: JSON.stringify(body)
  });

  let handleError = true;

  return extendPromise(async () => {
    let resp;
    try {
      const res = await req;
      const data = await res.json();

      resp = new Response(res.status, data);
    } catch(e) {
      console.error(e);
      resp = new Response(501, { code: 'connection_error' });
    }
    if(handleError) {
      if(resp.handleError()) {
        return null;
      }

      return resp.data;
    }

    return resp;
  }, {
    noHandleError() {
      handleError = false;
      return this;
    }
  });
}


class Response {
  constructor(status, data) {
    this._status = status;
    this._data = data;
  }

  get ok() {
    return this._status === 200;
  }


  handleError() {
    if(this.error) {
      handleRequestError(this.error);
      return true;
    } else {
      return false;
    }
  }

  get error() {
    if(this._status === 200) {
      return null;
    }

    return new ResponseError(this._data);
  }

  get data() {
    return this._data;
  }

}

class ResponseError {
  constructor(errorData) {
    this.lead = errorData;
  }

  is(code) {
    return this.data.code === code;
  }

  get code() {
    return this.data.code;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/api/core.js